module.exports = __webpack_public_path__ + "media/images/plans/plan-detail-icon-waiting-room-c4aa443f49c16704c3470c9ba4d7d00d.png";